import styled from 'styled-components';
import MUIList from '@material-ui/core/List';
import MUIListItem, { ListItemTypeMap } from '@material-ui/core/ListItem';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

export const List = styled(MUIList)`
  display: flex;

  ${({ theme: { breakpoints } }) => `
  overflow-x: scroll;

  ${breakpoints.up('sm')} {
    overflow-x: unset
  }
`}
 
  
`;

export const ListItem: OverridableComponent<
  ListItemTypeMap<{ button?: false }, 'li'>
> = styled(MUIListItem)`
  width: auto;
  margin-right: 18px;
  padding: 0;
  flex: 0 0 auto;

  &:last-child {
    margin-right: 0;
  }
`;
